<ng-template #addModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Point Adjustment</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="table w-100">
			<table class="table table-sm w-100">
				<tr>
					<td><mat-form-field appearance="outline" class="w-100">
								<mat-label>Point Value</mat-label>
								<input
									matInput
									[formControl]="pointvalue"
									required />
							</mat-form-field></td>
					<td><mat-form-field appearance="outline" class="w-100">
								<mat-label>Adjustment Reason</mat-label>
								<input
									matInput
									[formControl]="comment"
									required />
							</mat-form-field></td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer">
		<button color="primary" mat-stroked-button (click)="postAdjustment()"> Post Adjustment </button>
	</div>
</ng-template>
<ng-template #transModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{selectedcust.debtorno}}.{{selectedcust.branchcode}} Transactions</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="table w-100" #print_table>
			<table class="table table-sm w-100">
				<tr>
				<th colspan="6">
				{{selectedcust.debtorno}}.{{selectedcust.branchcode}} Transactions
				</th>
				</tr>
				<tr>
				<th>Customer #</th>
				<th>Branch</th>
				<th>Document # / Adjustment Reason</th>
				<th>Location</th>
				<th>Date Posted</th>
				<th>Points Earned</th>
				</tr>
				<tr *ngFor="let t of selectedcust.transactions">
					<td>{{t.debtorno}}</td>
					<td>{{t.branchcode}}</td>
					<td>{{t.transno != 0 && t.transno ? t.transno : t.rewardtype}}</td>
					<td>{{t.loccode}}</td>
					<td>{{t.postdate | date: 'mediumDate'}}</td>
					<td>{{t.pointvalue }}</td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer">
		<button mat-raised-button (click)="exportXls(print_table)"
                                            class="btn-sm btn-success" style="margin-right: 5px;">
                                            <i class="fa fa-file-excel-o"></i> XLS
        </button>
		<button mat-raised-button (click)="exportPDF(print_table)"
                                            class="btn-sm btn-danger" style="margin-right: 5px;">
                                            <i class="fa fa-file-pdf-o"></i> PDF
        </button>
	</div>
</ng-template>
<ng-template #addRewardModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Reward Setup</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="table w-100">
			<form [formGroup]="rewardForm">
			<div class="table table-sm w-100">
				<div class="row">
					<div class="col-sm-6">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Reward Code</mat-label>
								<input
									matInput
									formControlName="rewardcode"
									required />
						</mat-form-field>
					</div>
					<div class="col-sm-3">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Point Cost</mat-label>
								<input
									matInput
									formControlName="pointcost"
									required />
						</mat-form-field>
					</div>
					<div class="col-sm-3">
						<mat-slide-toggle formControlName="active">Active</mat-slide-toggle>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-3">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Starting Date (optional)</mat-label>
								<input
									matInput
									formControlName="startdate"
									 />
						</mat-form-field>
					</div>
					<div class="col-sm-3">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Ending Date (optional)</mat-label>
								<input
									matInput
									formControlName="enddate"
								/>
						</mat-form-field>
					</div>
					<div class="col-sm-3">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Store Location (optional)</mat-label>
								<input
									matInput
									formControlName="loccode"
									 />
						</mat-form-field>
					</div>
					<div class="col-sm-3">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Reward Type</mat-label>
								<mat-select
									matInput
									formControlName="rewardtype">
								<mat-option value="P"> Item Reward </mat-option>
								<mat-option value="D"> Cash Discount Reward </mat-option>
								</mat-select>
						</mat-form-field>
					</div>
				</div>
				<div class="row" *ngIf="rewardForm.get('rewardtype').value=='P'">
					<div class="col-sm-6">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Item Number</mat-label>
								<input
									matInput
									formControlName="stockid"
									[matAutocomplete]="auto"
									required />
									<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                        <mat-option *ngFor="let prod of filteredProds | async" [value]="prod.stockid" >
                                            {{prod.stockid}} &nbsp;: {{prod.description}} &nbsp;
                                            <ng-container *ngIf="prod.discontinued == 1">
                                                <div class="row align-middle pull-right float-right mr-2">
                                                    <p class="italics fs-small">Discontinued</p>
                                                </div>
                                            </ng-container>
                                        </mat-option>
                                    </mat-autocomplete>
						</mat-form-field>
						
					</div>
					<div class="col-sm-6">
						{{ rewardstockdesc }}
					</div>
				</div>
				<div class="row" *ngIf="rewardForm.get('rewardtype').value=='D'">
					<div class="col-sm-12">
						<mat-form-field appearance="outline" class="w-100">
								<mat-label>Discount Amount</mat-label>
								<input
									matInput
									formControlName="discount"
									required />
						</mat-form-field>
					</div>
				</div>
			</div>
			</form>
		</div>
	</div>
	<div class="modal-footer">
		<button color="primary" mat-stroked-button (click)="saveReward()"> Save Reward Entry </button>
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Customer Rewards</h4>
						<p class="card-category"></p>
					</div>
					<div class="card-body">
						<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
							<mat-tab label="Customer Balances">
								<ng-template matTabContent>				
									<div class="container-fluid">
										<div class="table ov">
											<div class="text-right"> Results ({{searchingcustomers.length}})</div>
											<div class="row m-0 p-0">
												<div class="col-3">
													<mat-form-field appearance="outline" class="search-field">
													<mat-label>Search Customers</mat-label>
													<input matInput placeholder="Search..." [formControl]="customersearch" (input)="filterCust()">
													<button matSuffix mat-icon-button aria-label="Clear" *ngIf="customersearch.value" (click)="clearCSearch()">
													<mat-icon>clear</mat-icon>
													</button>
													</mat-form-field>
												</div>
												<div class="col-3">
													<mat-form-field appearance="outline">
													<mat-label>Active?</mat-label>
													<mat-select [formControl]="activecust" (selectionChange)="getCustomers();">
													<mat-option value="1">Only Customers w/ Point Totals</mat-option>
													<mat-option value="0">All Customers</mat-option>
													</mat-select>
													</mat-form-field>
												</div>
												<div class="col-6">
													<mat-paginator #paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
												</div>
											</div>
												<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" >
													<thead class="header">
														<tr>
															<th></th>
															<th class="header" scope="col">Customer #</th>
															<th class="header" scope="col">Branch</th>
															<th class="header" scope="col">Name</th>
															<th class="header" scope="col">First Purchase Date</th>
															<th class="header text-right" scope="col">Total Points Earned</th>
															<th class="header text-right" scope="col">Current Point Balance</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let p of dataObs | async">
															<td>
																<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More">
																	<mat-icon>more_vert</mat-icon>
																</button>
																<mat-menu #menu="matMenu">
																	<button mat-menu-item color="accent" aria-label="" (click)="showTrans(p)">
																		<mat-icon>view_list</mat-icon> Show Transactions
																	</button>
																	<button mat-menu-item color="accent" aria-label="" (click)="adjust(p)">
																		<mat-icon>edit</mat-icon> Adjust Points
																	</button>

																</mat-menu>
															</td>
															<td>{{ p.debtorno }}</td>
															<td>{{ p.branchcode }}</td>
															<td>{{ p.brname }}</td>
															<td class="text-center">{{ p.firstdate | date: 'shortDate' :'': 'en_CA' }}</td>
															<td class="text-right">{{ p.totalpoints }}</td>
															<td class="text-right">{{ p.points }}</td>
														</tr>
														<tr *ngIf="(dataObs | async)?.length === 0">
															<td colspan="7" class="text-center">
																<p class="text-muted mt-3 mb-3">No customer balances found</p>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
								</ng-template>
							</mat-tab>
							<mat-tab label="Reward Setup">
								<ng-template matTabContent>		
										<div class="container-fluid">
											
											<div class="row m-0 p-0">
												<div class="col-2">
												<button mat-stroked-button (click)="addReward()"> Add Reward</button>
											
												</div>
												<div class="col-4">
													<mat-form-field appearance="outline" class="search-field">
													<mat-label>Search Rewards</mat-label>
													<input matInput placeholder="Search..." [formControl]="rewardsearch" (input)="filterRewards()">
													<button matSuffix mat-icon-button aria-label="Clear" *ngIf="rewardsearch.value" (click)="clearRSearch()">
													<mat-icon>clear</mat-icon>
													</button>
													</mat-form-field>
												</div>
												
												<div class="col-6">
													<mat-paginator #paginator2 [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
												</div>
											</div>
											<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" >
													<thead class="header">
														<tr>
															<th></th>
															<th class="header" scope="col">Reward Code</th>
															<th class="header" scope="col">Point Cost</th>
															<th class="header" scope="col">Starting Date</th>
															<th class="header" scope="col">Ending Date</th>
															<th class="header" scope="col">Location</th>
															<th class="header" scope="col">Effect</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let p of dataObs2 | async">
															<td>
																<button mat-icon-button [matMenuTriggerFor]="menu2" aria-label="More">
																	<mat-icon>more_vert</mat-icon>
																</button>
																<mat-menu #menu2="matMenu">
																	<button mat-menu-item color="accent" aria-label="" (click)="editReward(p)">
																		<mat-icon>edit</mat-icon> Edit
																	</button>
																	<button mat-menu-item color="accent" aria-label="" (click)="removeReward(p)">
																		<mat-icon>remove</mat-icon> Delete
																	</button>

																</mat-menu>
															</td>
															<td>{{ p.rewardtype }}</td>
															<td>{{ p.pointvalue }}</td>
															<td>{{ p.datefrom | date: 'mediumDate' }}</td>
															<td>{{ p.dateto | date: 'mediumDate' }}</td>
															<td class="text-center">{{ p.loccode ? p.loccode : 'ALL' }}</td>
															<td class="text-center">{{ p.description }}</td>
														</tr>
														<tr *ngIf="(dataObs2 | async)?.length === 0">
															<td colspan="7" class="text-center">
																<p class="text-muted mt-3 mb-3">No rewards configured</p>
															</td>
														</tr>
													</tbody>
												</table>
										</div>
										
								</ng-template>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>